export class InvMasterSerialsLogEntity{
    id:number;
    userId:number;
    creationDate:string;
    pallet:string;
    constructor (){}
}